import { useState, useEffect, useCallback } from 'react';
import { designationService } from 'Services/AdminServices/Organization/Designation';

export const useDesignations = () => {
  const [designations, setDesignations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedStatus, setSelectedStatus] = useState('All');
  const [ rankOptions, setRankOptions] = useState([]);
  const [ rankLoading , setRankLoading] = useState(false);

  const fetchData = useCallback(async () => {
    setLoading(true);
    try {
      // POST API (no filter initially)
      const data = await designationService.getDesignations();
      setDesignations(data || []);
    } catch (err) {
      console.error("Hook Error:", err);
    } finally {
      setLoading(false);
    }
  }, []);

 const fetchRankOptions = async (level) => {
  try {
    setRankLoading(true);
    const data = await designationService.getRankOptions(level);
    setRankOptions(data || []);
  } catch (error) {
    console.error("Rank API error:", error);
    setRankOptions([]);
  } finally {
    setRankLoading(false);  
  }
};

  const createDesignation = async (paylaod) => {
    try {
           await designationService.createDesignation(paylaod);
    }
    catch(error){
      
    }
  }

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const getByLevel = (level) => {
    return designations.filter(d =>
      d.level === level &&
      (selectedStatus === 'All'
        ? true
        : selectedStatus === 'Active'
          ? d.isActive
          : !d.isActive)
    );
  };

  const stats = {
    total: designations.length,
    active: designations.filter(d => d.isActive).length,
    totalEmployees: designations.reduce(
      (acc, curr) => acc + (curr.employeeCount || 0),
      0
    ),
  };

  return {
    designations,
    stats,
    loading,
    getByLevel,
    selectedStatus,
    setSelectedStatus,
    rankLoading,
    rankOptions,
    createDesignation,
    fetchRankOptions,
    fetchData
  };
};